import { ContinueButton } from '@core/blocks/edu-flow-2/components/NavigationButtons/ContinueButton/continueButtonsTypeDictionary';
import { type ContinueButtonTypes } from '@core/blocks/edu-flow/components/Page/types';

import PopupButton from './PopupButton';
import SubmitButton from './SubmitButton';

const continueButtonsTypeDictionary: Record<ContinueButtonTypes, ContinueButton> = {
  popupButton: PopupButton,
  defaultButton: SubmitButton,
};

export default continueButtonsTypeDictionary;
